import Icon from "@Atom/Icon";
import Styles from "./styles.module.scss";
import { fileBaseUrl } from "@Config/api";
import Images from "@Theme/Images";
import { rupiahFormat } from "@Helpers/formatRupiah";
import { useMemo, useState } from "react";
import { Skeleton, Tooltip } from "@mui/material";
import {
  createCandidateBookmark,
  deleteCandidateBookmark,
} from "@Services/home";
import { useNavigate } from "react-router-dom";

export default function DetailJobSeeker({
  data,
  isPreview = false,
  setTrigger = () => {},
  setSuccess = () => {},
  setError = () => {},
  setShowShareModal = () => {},
  handleApply = () => {},
  loading = false,
  isLoadingCopyLink = false,
  isHide = false,
}) {
  const startIndex = 0;
  const endIndex = 1;
  const navigate = useNavigate();

  const maxLengthAddress = 28;

  function changeFormatPlacement(str) {
    return str.replaceAll("::", ", ");
  }

  function toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  const slicedItems = useMemo(() => {
    if (data?.placement?.length > 1) {
      return data?.placement?.slice(endIndex);
    }
  }, [data?.placement]);

  const selectedItems = useMemo(() => {
    if (data?.placement?.length > 0) {
      return data?.placement?.slice(startIndex, endIndex);
    }
    return [];
  }, [data?.placement]);

  const slicedItemsCategories = useMemo(() => {
    if (data?.categories?.length > 1) {
      return data?.categories?.slice(endIndex);
    }
  }, [data?.categories]);

  const selectedItemsCategories = useMemo(() => {
    if (data?.categories?.length > 0) {
      return data?.categories?.slice(startIndex, endIndex);
    }
    return [];
  }, [data?.categories]);

  const isHtml = (str) => {
    const doc = new DOMParser().parseFromString(str, "text/html");
    return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
  };

  const [isLoading, setIsLoading] = useState(false);

  const updateBookmark = async (e, jobPostID, action) => {
    try {
      e.preventDefault();
      setIsLoading(true);
      if (action === true) {
        await deleteCandidateBookmark(jobPostID);
      } else {
        await createCandidateBookmark(jobPostID);
      }

      setIsLoading(false);
      setError("");
      setSuccess(
        action === true
          ? "Loker berhasil tersimpan"
          : "Loker sudah tidak tersimpan lagi"
      );
      setTrigger(Math.random());
    } catch (error) {
      console.log(error);
      setError(error.response?.data?.error);
      setIsLoading(false);
      setSuccess("");
    }
  };

  return (
    <div className={Styles.container}>
      {isPreview && (
        <div
          className={`${Styles.statusBox} ${
            data?.status === "Draft" && Styles.draft
          } ${data?.status === "Publish" && Styles.publish} ${
            data?.status === "Unpublish" && Styles.unPublish
          }`}
        >
          <span>
            {data?.status === "Draft"
              ? "Loker dalam status Draft"
              : data?.status === "Publish"
              ? "Loker telah aktif"
              : data?.status === "Unpublish"
              ? "Loker sudah ditutup"
              : "Loker dalam status menunggu verifikasi"}
          </span>

          <div>
            <Icon
              icon={
                data?.status === "Draft"
                  ? "folder"
                  : data?.status === "Publish"
                  ? "star-check"
                  : data?.status === "Unpublish"
                  ? "calendar-status"
                  : "time"
              }
              size={20}
              color={
                data?.status === "Draft"
                  ? "#1571DE"
                  : data?.status === "Publish"
                  ? "#27BB83"
                  : data?.status === "Unpublish"
                  ? "#757575"
                  : "#96AB12"
              }
            />
          </div>
        </div>
      )}

      <div className={Styles.contentBox}>
        <div className={Styles.headerProfile}>
          <div className={Styles.leftheader}>
            <div className={Styles.imagesBox}>
              {loading ? (
                <Skeleton variant="circular" width={60} height={60} />
              ) : (
                <img
                  src={
                    data?.iconUri
                      ? fileBaseUrl + data?.iconUri
                      : Images.PERAMATA_LOGO_CICRLE
                  }
                  alt=""
                />
              )}
            </div>
            <div className={Styles.titleBox}>
              {loading ? (
                <Skeleton />
              ) : (
                <span className={Styles.title}>{data?.title || "-"}</span>
              )}

              {loading ? (
                <Skeleton />
              ) : (
                <div className={Styles.clientBox}>
                  <div>
                    <Icon
                      icon={"buildings-preview"}
                      size={20}
                      color={"#91BDF1"}
                    />
                  </div>
                  <span>{data?.clientName || "-"}</span>
                </div>
              )}
            </div>
          </div>

          <div className={Styles.description}>
            <div className={Styles.titleBox}>
              {loading ? (
                <Skeleton />
              ) : (
                <span className={Styles.title}>{data?.title || "-"}</span>
              )}

              {loading ? (
                <Skeleton />
              ) : (
                <div className={Styles.clientBox}>
                  <div>
                    <Icon
                      icon={"buildings-preview"}
                      size={20}
                      color={"#91BDF1"}
                    />
                  </div>
                  <span>{data?.clientName || "-"}</span>
                </div>
              )}
            </div>

            {loading ? (
              <div className={Styles.listBox}>
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
              </div>
            ) : (
              <div className={Styles.listBox}>
                {data?.salary && (
                  <div>
                    <div className={Styles.icon}>
                      <Icon
                        icon={"dollar-outline"}
                        size={20}
                        color={"#757575"}
                      />
                    </div>
                    <span className={Styles.text}>
                      {data?.salary?.split("-")?.map((s, is, arr) => (
                        <span key={is}>
                          {rupiahFormat(
                            +s
                              ?.replace(".", ",")
                              .replace(/\d{3}(?=(\d{3})*,)/g, function (s) {
                                return "." + s;
                              })
                          )}{" "}
                          {arr.length > 1 && is === 0
                            ? " - "
                            : is !== 0
                            ? " /bulan"
                            : "/bulan"}
                        </span>
                      ))}
                    </span>
                  </div>
                )}
                {data?.workSystem || data?.workMethod ? (
                  <div>
                    <div className={Styles.icon}>
                      <Icon icon={"clock"} size={20} color={"#757575"} />
                    </div>
                    <span className={Styles.textBox}>
                      {data?.workSystem || "-"}
                      <div className={Styles.bullet}></div>
                      {data?.workMethod || "-"}
                    </span>
                  </div>
                ) : null}
                {data?.requirements?.find((requirement) =>
                  requirement.value.includes("Pendidikan terakhir")
                ) && (
                  <div>
                    <div className={Styles.icon}>
                      <Icon icon={"graduation"} size={20} color={"#757575"} />
                    </div>

                    <span className={Styles.text}>
                      Minimal{" "}
                      {data?.requirements
                        ?.find((requirement) =>
                          requirement.value.includes("Pendidikan terakhir")
                        )
                        ?.value?.split(":")[1]
                        ?.trim() || "-"}
                    </span>
                  </div>
                )}

                <div>
                  <div className={Styles.icon}>
                    <Icon
                      icon={"map-point-outline"}
                      size={20}
                      color={"#757575"}
                    />
                  </div>
                  {Array.isArray(data?.placement) ? (
                    <Tooltip
                      title={
                        <span>
                          {toTitleCase(
                            changeFormatPlacement(
                              data?.placement
                                ?.map((item) => item.city)
                                .join(", ")
                            )
                          ) || "-"}
                        </span>
                      }
                    >
                      <div className={Styles.textBox}>
                        <span className={Styles.text}>
                          {selectedItems?.length > 0
                            ? selectedItems.map((item) => item.city).join(", ")
                                ?.length > maxLengthAddress
                              ? toTitleCase(
                                  changeFormatPlacement(
                                    selectedItems
                                      .map((item) => item.city)
                                      .join(", ")
                                  )
                                )?.substring(0, maxLengthAddress) + "..."
                              : toTitleCase(
                                  changeFormatPlacement(
                                    selectedItems
                                      .map((item) => item.city)
                                      .join(", ")
                                  )
                                )
                            : "-"}
                        </span>

                        {data?.placement?.length > 1 ? (
                          <span className={Styles.text}>
                            +{slicedItems?.length}
                          </span>
                        ) : null}
                      </div>
                    </Tooltip>
                  ) : (
                    <Tooltip
                      title={
                        <span>
                          {toTitleCase(changeFormatPlacement(data?.placement))}
                        </span>
                      }
                    >
                      <span className={Styles.text}>
                        {" "}
                        {data?.placement
                          ? data?.placement.length > maxLengthAddress
                            ? toTitleCase(
                                changeFormatPlacement(data?.placement)
                              ).substring(0, maxLengthAddress) + "..."
                            : toTitleCase(
                                changeFormatPlacement(data?.placement)
                              )
                          : "-"}
                      </span>
                    </Tooltip>
                  )}
                </div>

                <div>
                  <div className={Styles.icon}>
                    <Icon icon={"other-company"} size={20} color={"#757575"} />
                  </div>
                  <div className={Styles.positionTextBox}>
                    <Tooltip
                      title={
                        <span>
                          {toTitleCase(
                            changeFormatPlacement(
                              data?.categories
                                ?.map((item) => item.value)
                                .join(", ")
                            )
                          ) || "-"}
                        </span>
                      }
                    >
                      <div className={Styles.position}>
                        <span className={Styles.positionText}>
                          {selectedItemsCategories?.length > 0
                            ? selectedItemsCategories
                                .map((item) => item.value)
                                .join(", ")
                            : "-"}
                        </span>

                        {data?.categories?.length > 1 ? (
                          <span className={Styles.positionText}>
                            +{slicedItemsCategories?.length}
                          </span>
                        ) : null}
                      </div>
                    </Tooltip>
                    <Icon icon={"arrow-right"} size={20} color={"#09121F"} />
                    <span className={Styles.positionText}>
                      {data?.title || "-"}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {!isPreview && (
              <div className={Styles.buttonAction}>
                <button
                  disabled={
                    data?.status === "Unpublish" ||
                    loading ||
                    isLoadingCopyLink ||
                    data?.isApplied === true
                  }
                  onClick={handleApply}
                >
                  {isLoadingCopyLink ? "Loading..." : "Lamar Sekarang"}
                </button>
                <button
                  disabled={
                    data?.status === "Unpublish" || isLoading || loading
                  }
                  onClick={(e) => {
                    if (!localStorage?.getItem("accessTokenUserLanding")) {
                      navigate(`/user/login`);
                    } else {
                      updateBookmark(e, data?._id, data?.isBookmarked);
                    }
                  }}
                >
                  {isLoading
                    ? "Loading..."
                    : data?.isBookmarked
                    ? "Tersimpan"
                    : "Simpan"}
                  <Icon
                    icon={data?.isBookmarked ? "bookmark" : "archive"}
                    size={20}
                    color={"#1571DE"}
                  />
                </button>
                <button
                  disabled={data?.status === "Unpublish" || loading}
                  onClick={() => {
                    setShowShareModal(true);
                  }}
                >
                  Bagikan
                  <Icon icon={"share"} size={20} color={"#1571DE"} />
                </button>
              </div>
            )}
          </div>
        </div>

        <div className={Styles.descriptionBox}>
          {loading && (
            <>
              <Skeleton />
              <Skeleton />
              <Skeleton />
            </>
          )}
          {!loading && data?.evaluations?.length > 0 && (
            <div className={Styles.skillsBox}>
              <span className={Styles.titleSkills}>Skills yang Dibutuhkan</span>
              <div className={Styles.skills}>
                {data?.evaluations?.map((el, idx) => {
                  return <div key={idx}>{el?.label || "-"}</div>;
                })}
              </div>
            </div>
          )}

          {!loading && data?.description && (
            <div className={Styles.skillsBox}>
              <span className={Styles.titleSkills}>Deskripsi Pekerjaan</span>
              {isHtml(data?.description) ? (
                <div
                  style={{ marginLeft: "16px" }}
                  dangerouslySetInnerHTML={{ __html: data.description }}
                />
              ) : (
                <span className={Styles.textSpan}>{data?.description}</span>
              )}
            </div>
          )}
        </div>
      </div>

      {!isHide && (
        <div className={Styles.warningBox}>
          <div className={Styles.star}>
            <Icon icon={"star"} color={"#96AB12"} size={24} />
          </div>

          <div className={Styles.descWarning}>
            <span>Tips Menjaga Diri</span>
            <span>
              Perusahaan dan lowongan pekerjaan di Kerja365 tidak akan meminta
              data pribadi, informasi rekening, atau pembayaran dalam proses
              lamaran. Waspadalah terhadap lowongan yang menggunakan Google Form
              atau grup Telegram tanpa verifikasi yang jelas.
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
